// uat 
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "./Layout";
import "./UserDetailsForm.css";
// import userBgDesktop from '../assets/login_page_4k.jpg';
// import userBgMobile from '../assets/login_phone.jpg';
import userBgDesktop from '../assets/login_page_4k_latest.jpg';
import userBgMobile from '../assets/login_phone_long.jpg';
import { useBackground } from '../context/BackgroundContext';
import { useSessionKey } from '../context/SessionKeyContext';
import { encryptAES,decryptAES } from "../utils/cryptoUtils"; 
import { useAuth } from '../context/AuthContext';
import { createApiClient } from '../utils/api';

const UserDetailsForm = () => {
  const { sessionKey } = useSessionKey();
  const { apiJwt } = useAuth();
  const apiClient = createApiClient(apiJwt);

  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    termsAccepted: false,
  });

  // State for the Disclaimer Popup
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  const { changeBackground } = useBackground();
  const navigate = useNavigate();

  useEffect(() => {
    changeBackground(userBgDesktop);
  }, [changeBackground]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 600);
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

useEffect(() => {
  changeBackground(isMobile ? userBgMobile : userBgDesktop);
}, [changeBackground, isMobile]);

useEffect(() => {
  if (window.innerWidth <= 600) {
    document.body.style.overflow = "hidden"; // card scrolls
  } else {
    document.body.style.overflow = "hidden"; // desktop modal
  }

  return () => {
    document.body.style.overflow = "auto";
  };
}, []);


  // Disclaimer Text from your previous file
  const disclaimerText = `
    By proceeding, you acknowledge and agree to the following:
    1. I hereby declare that I am the  parent or the legally appointed guardian of the child whose data and image are being uploaded and that I have the legal right to share the child's data for this digital activity
    2. I confirm that I am providing my personal details (Name, Contact, Email) and my child’s details (Name, DOB, Gender, Image) voluntarily for the Aspire AI tool and certify that all information provided is accurate
    3. I consent to the use of my child’s image and data by ICICI Prudential Life Insurance and its authorised technology partners to generate an AI-enhanced image of my child in their desired career attire
    4. I may choose to avail a physical print copy of the generated image and acknowledge that to facilitate the delivery of a physical print, the generated image and my contact details will be shared with an ICICI Prudential Life Insurance employee or advisor/ authorised vendor
    5. The information provided will be stored until necessary to fulfil the specified purpose and processed in accordance with the Company’s Privacy Policy and applicable laws
    6. I understand that the AI-generated image is for representational and engagement purposes only. The company does not guarantee the visual accuracy or quality of the final output
    7. By providing my phone number and email ID, I expressly authorise ICICI Prudential Life Insurance and its representatives to contact me via Call, SMS, WhatsApp, or Email for marketing, promotional offers, and insurance product information, notwithstanding any DND (Do Not Disturb) registration
  `;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Open the popup
  const openDisclaimer = (e) => {
    e.preventDefault(); // Prevent default label behavior
    setShowDisclaimer(true);
  };

  // Close popup without accepting
  const closeDisclaimer = () => {
    setShowDisclaimer(false);
  };

  // Accept terms from the popup
  const handleAgree = () => {
    setFormData((prev) => ({ ...prev, termsAccepted: true }));
    setShowDisclaimer(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.phone.length !== 10) {
      alert("Please enter a valid 10-digit phone number.");
      return;
    }
    if (!formData.termsAccepted) {
      alert("Please accept the terms & conditions.");
      return;
    
    }

    // uat
    const { fullName, phone, email } = formData;
    const encryptedPayload = encryptAES(JSON.stringify({ session_challenge_id: sessionKey, formData: formData}));

    const unwrap = (p) => {
      return JSON.parse(decryptAES(p.encryptedResponse));
    };
    
    try {
      // // uat
      // const rawdata = await apiClient.post('https://api-uat.iciciprulife.com/biu/aspireai/user/details', {
      // encryptedRequest: encryptedPayload,
      // });

      // prod
      const rawdata = await apiClient.post('https://api.iciciprulife.com/biu/aspireai/user/details', {
      encryptedRequest: encryptedPayload,
      })

      console.log("Before decryption rawdata", rawdata)

      const data = await rawdata.json();

      console.log("Before decryption json data", data)

      if (!rawdata.ok) {
        const errorData = unwrap(data);
        throw new Error(errorData.error || errorData.message || 'Failed to get more info');
      }

      const response = unwrap(data);
      console.log("Decrypted Response", response)

      if (response.error) {
        alert(`Error: ${response.error}`);
      }else {
        console.log("User details submitted:", data);
        navigate("/capture-photo");
      }
    } catch (error) {
      console.error("Error submitting details:", error);
      alert("Failed to submit details.");
    }
  };

return (
  <Layout>
    <div className="user-details-card">
      <h2>
        Please fill in your details.
      </h2>

      <form onSubmit={handleSubmit} className="details-form">
        <input
          type="text"
          name="fullName"
          placeholder="Enter your Full Name"
          value={formData.fullName}
          onChange={handleChange}
          required
        />
        <input
          type="tel"
          name="phone"
          placeholder="Phone No."
          value={formData.phone}
          onChange={handleChange}
          maxLength="10"
          pattern="[0-9]{10}"
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        
        <label className="checkbox-label">
          <input
            type="checkbox"
            name="termsAccepted"
            checked={formData.termsAccepted}
            onChange={openDisclaimer}
          />
          <span>
            Accept terms and conditions
          </span>
        </label>

        <button type="submit" className="submit-button">
          SUBMIT
        </button>
      </form>
    </div>

    {/* --- POPUP MODAL --- */}
    {showDisclaimer && (
      <div className="modal-overlay">
        <div className="modal-content">
          <h3>User consent and disclaimer</h3>
          <div className="modal-body">
            {disclaimerText.split('\n').map((line, index) => (
              <p key={index}>{line}</p>
            ))}
          </div>
          <div className="modal-actions">
            <button className="modal-btn cancel" onClick={closeDisclaimer}>
              Cancel
            </button>
            <button className="modal-btn agree" onClick={handleAgree}>
              Agree and continue
            </button>
          </div>
        </div>
      </div>
    )}
  </Layout>
);
};

export default UserDetailsForm; 



// local testing
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import Layout from "./Layout";
// import "./UserDetailsForm.css";
// import userBgDesktop from '../assets/login_page_4k_latest.jpg';
// import userBgMobile from '../assets/login_phone_long.jpg';
// import { useBackground } from '../context/BackgroundContext';

// const UserDetailsForm = () => {

//   const [formData, setFormData] = useState({
//     fullName: "",
//     phone: "",
//     email: "",
//     termsAccepted: false,
//   });

//   // State for the Disclaimer Popup
//   const [showDisclaimer, setShowDisclaimer] = useState(false);

//   const { changeBackground } = useBackground();
//   const navigate = useNavigate();

//   useEffect(() => {
//     changeBackground(userBgDesktop);
//   }, [changeBackground]);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

// useEffect(() => {
//   const handleResize = () => {
//     setIsMobile(window.innerWidth <= 600);
//   };

//   window.addEventListener("resize", handleResize);
//   return () => window.removeEventListener("resize", handleResize);
// }, []);

// useEffect(() => {
//   changeBackground(isMobile ? userBgMobile : userBgDesktop);
// }, [changeBackground, isMobile]);

// useEffect(() => {
//   if (window.innerWidth <= 600) {
//     document.body.style.overflow = "hidden"; // card scrolls
//   } else {
//     document.body.style.overflow = "hidden"; // desktop modal
//   }

//   return () => {
//     document.body.style.overflow = "auto";
//   };
// }, []);


//   // Disclaimer Text from your previous file
//   const disclaimerText = `
//     By proceeding, you acknowledge and agree to the following:
//     1. I hereby declare that I am the  parent or the legally appointed guardian of the child whose data and image are being uploaded and that I have the legal right to share the child's data for this digital activity
//     2. I confirm that I am providing my personal details (Name, Contact, Email) and my child’s details (Name, DOB, Gender, Image) voluntarily for the Aspire AI tool and certify that all information provided is accurate
//     3. I consent to the use of my child’s image and data by ICICI Prudential Life Insurance and its authorised technology partners to generate an AI-enhanced image of my child in their desired career attire
//     4. I may choose to avail a physical print copy of the generated image and acknowledge that to facilitate the delivery of a physical print, the generated image and my contact details will be shared with an ICICI Prudential Life Insurance employee or advisor/ authorised vendor
//     5. The information provided will be stored until necessary to fulfil the specified purpose and processed in accordance with the Company’s Privacy Policy and applicable laws
//     6. I understand that the AI-generated image is for representational and engagement purposes only. The company does not guarantee the visual accuracy or quality of the final output
//     7. By providing my phone number and email ID, I expressly authorise ICICI Prudential Life Insurance and its representatives to contact me via Call, SMS, WhatsApp, or Email for marketing, promotional offers, and insurance product information, notwithstanding any DND (Do Not Disturb) registration
//   `;

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   // Open the popup
//   const openDisclaimer = (e) => {
//     e.preventDefault(); // Prevent default label behavior
//     setShowDisclaimer(true);
//   };

//   // Close popup without accepting
//   const closeDisclaimer = () => {
//     setShowDisclaimer(false);
//   };

//   // Accept terms from the popup
//   const handleAgree = () => {
//     setFormData((prev) => ({ ...prev, termsAccepted: true }));
//     setShowDisclaimer(false);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (formData.phone.length !== 10) {
//       alert("Please enter a valid 10-digit phone number.");
//       return;
//     }
//     if (!formData.termsAccepted) {
//       alert("Please accept the terms & conditions.");
//       return;
    
//     }

//   // local testing
//     try {
//       const response = await fetch("http://127.0.0.1:8028/aspireai/user-details", {
//         credentials: "include",
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           // 'X-Access-Key': sessionKey,
//         },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();

//       if (response.error) {
//         alert(`Error: ${response.error}`);
//       } else {
//         console.log("User details submitted:", data);
//         navigate("/capture-photo");
//       }
//     } catch (error) {
//       console.error("Error submitting details:", error);
//       alert("Failed to submit details.");
//     }
//   };

//   return (
//     <Layout>
//       <div className="user-details-card">
//         <h2>
//           Please fill in your details.
//         </h2>

//         <form onSubmit={handleSubmit} className="details-form">
//           <input
//             type="text"
//             name="fullName"
//             placeholder="Enter your Full Name"
//             value={formData.fullName}
//             onChange={handleChange}
//             required
//           />
//           <input
//             type="tel"
//             name="phone"
//             placeholder="Phone No."
//             value={formData.phone}
//             onChange={handleChange}
//             maxLength="10"
//             pattern="[0-9]{10}"
//             required
//           />
//           <input
//             type="email"
//             name="email"
//             placeholder="Email"
//             value={formData.email}
//             onChange={handleChange}
//             required
//           />
          
//           <label className="checkbox-label">
//             <input
//               type="checkbox"
//               name="termsAccepted"
//               checked={formData.termsAccepted}
//               onChange={openDisclaimer}
//             />
//             <span>
//               Accept terms and conditions
//             </span>
//           </label>

//           <button type="submit" className="submit-button">
//             SUBMIT
//           </button>
//         </form>
//       </div>

//       {/* --- POPUP MODAL --- */}
//       {showDisclaimer && (
//         <div className="modal-overlay">
//           <div className="modal-content">
//             <h3>User consent and disclaimer</h3>
//             <div className="modal-body">
//               {disclaimerText.split('\n').map((line, index) => (
//                 <p key={index}>{line}</p>
//               ))}
//             </div>
//             <div className="modal-actions">
//               <button className="modal-btn cancel" onClick={closeDisclaimer}>
//                 Cancel
//               </button>
//               <button className="modal-btn agree" onClick={handleAgree}>
//                 Agree and continue
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </Layout>
//   );
// };

// export default UserDetailsForm; 